import React from "react"

export default class Question extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className={this.props.className}>
				<div className="QuestionInnerWrapper">
					<div className="QuestionNumberAndLabel">
						{/*<div className="QuestionNumber">
							{this.props.number}.
						</div>*/}
						<div className="QuestionLabel" dangerouslySetInnerHTML={{__html: this.props.label}}></div>
					</div>
					<div className="QuestionComponent">
						{this.props.children}
					</div>
				</div>
			</div>
		);
	}

}